import localRequest from './LocalServer/localRequest';

export const setVariable = async () => {
  await new Promise(async (resolve, reject) => {
    await localRequest({
      method: 'get',
      url: `/env`,
    }).then((res) => {
      console.log(res.data);
      // localStorage.setItem('HIDE_CARDS', res.data?.REACT_APP_HIDE_CARDS);
      // localStorage.setItem('LOGOUT', res.data?.REACT_APP_LOGOUT);
      // localStorage.setItem('SKIP_PAYMENT', res.data?.REACT_APP_SKIP_PAYMENT);
      // localStorage.setItem('HIDE_TAX', resw.data?.REACT_APP_HIDE_TAX);

      localStorage.setItem('ISLOCAL', res.data?.REACT_APP_ISLOCAL);
      localStorage.setItem('INI_TIME', res.data?.REACT_APP_INI_TIME);
      localStorage.setItem('EURO_FLAG', res.data?.REACT_APP_EURO_FLAG);

      localStorage.setItem('MOBILE_PAY', res.data?.REACT_APP_MOBILE_PAY);
      localStorage.setItem('CASH_PAY', res.data?.REACT_APP_CASH_PAY);
      localStorage.setItem('AE_PAY', res.data?.REACT_APP_AE_PAY);
      localStorage.setItem('DC_PAY', res.data?.REACT_APP_DC_PAY);
      localStorage.setItem('DIS_PAY', res.data?.REACT_APP_DIS_PAY);
      localStorage.setItem('JCB_PAY', res.data?.REACT_APP_JCB_PAY);
      localStorage.setItem('TW_SPAIN', res.data?.REACT_APP_TW_SPAIN);

      localStorage.setItem('send_order_third', res.data?.REACT_APP_SEND_ORDER_THIRD);
      resolve(0);
    });
  });
};
